var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 11.9333C29.8998 11.9166 29.7831 11.9166 29.6831 11.9333C27.3831 11.8499 25.5498 9.96659 25.5498 7.63325C25.5498 5.24992 27.4665 3.33325 29.8498 3.33325C32.2331 3.33325 34.1498 5.26659 34.1498 7.63325C34.1331 9.96659 32.2998 11.8499 29.9998 11.9333Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2829 24.0666C30.5662 24.4499 33.0829 24.0499 34.8496 22.8666C37.1996 21.2999 37.1996 18.7333 34.8496 17.1666C33.0663 15.9833 30.5162 15.5833 28.2329 15.9833",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94981 11.9333C10.0498 11.9166 10.1665 11.9166 10.2665 11.9333C12.5665 11.8499 14.3998 9.96659 14.3998 7.63325C14.3998 5.24992 12.4831 3.33325 10.0998 3.33325C7.71647 3.33325 5.7998 5.26659 5.7998 7.63325C5.81647 9.96659 7.64981 11.8499 9.94981 11.9333Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 24.0666C9.38323 24.4499 6.86657 24.0499 5.0999 22.8666C2.7499 21.2999 2.7499 18.7333 5.0999 17.1666C6.88324 15.9833 9.43323 15.5833 11.7166 15.9833",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 24.3835C19.9003 24.3668 19.7836 24.3668 19.6836 24.3835C17.3836 24.3001 15.5503 22.4168 15.5503 20.0834C15.5503 17.7001 17.467 15.7834 19.8503 15.7834C22.2336 15.7834 24.1503 17.7168 24.1503 20.0834C24.1336 22.4168 22.3003 24.3168 20.0003 24.3835Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1502 29.6333C12.8002 31.2 12.8002 33.7667 15.1502 35.3333C17.8169 37.1167 22.1835 37.1167 24.8502 35.3333C27.2002 33.7667 27.2002 31.2 24.8502 29.6333C22.2002 27.8667 17.8169 27.8667 15.1502 29.6333Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviders);
export default __webpack_public_path__ + "static/media/providers.23de90f483e3c7ddf7891861e055f6c1.svg";
export { ForwardRef as ReactComponent };